import { ACTION_TYPES } from '@constants';

const initialState = {
  isLogged: false,
  requestHasError: false,
  requestIsSuccess: false,
  isRefreshTokenSuccess: false,
  forgotPasswordEmail: '',
};

export default (
  state = initialState,
  action: { type: string; payload: any }
) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.LOGIN_SUCCESS:
      return {
        ...state,
        requestIsSuccess: true,
        requestHasError: true,
        isLogged: true,
        isRefreshTokenSuccess: true,
      };
    case ACTION_TYPES.LOGIN_FAILURE:
      return {
        ...state,
        requestHasError: true,
        requestIsSuccess: false,
        isLogged: false,
      };
    case ACTION_TYPES.LOGOUT:
      return {
        ...state,
        isLogged: false,
        requestHasError: false,
        requestIsSuccess: false,
      };
    case ACTION_TYPES.KEEP_LOGGED:
      return {
        ...state,
        isLogged: true,
      };
    case ACTION_TYPES.REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        requestHasError: false,
        requestIsSuccess: true,
        isRefreshTokenSuccess: true,
        isLogged: true,
      };
    case ACTION_TYPES.REFRESH_TOKEN_FAILURE:
      return {
        ...state,
        requestHasError: true,
        requestIsSuccess: false,
        isRefreshTokenSuccess: false,
      };
    case ACTION_TYPES.REQUEST_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        requestHasError: false,
        requestIsSuccess: true,
        forgotPasswordEmail: payload,
      };
    case ACTION_TYPES.REQUEST_FORGOT_PASSWORD_FAILURE:
      return {
        ...state,
        requestHasError: true,
        requestIsSuccess: false,
      };
    case ACTION_TYPES.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        requestHasError: false,
        requestIsSuccess: true,
      };
    case ACTION_TYPES.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        requestHasError: true,
        requestIsSuccess: false,
        forgotPasswordEmail: '',
      };
    case ACTION_TYPES.VERIFY_ACCOUNT_SUCCESS:
      return {
        ...state,
        requestHasError: false,
        requestIsSuccess: true,
      };
    case ACTION_TYPES.VERIFY_ACCOUNT_FAILURE:
      return {
        ...state,
        requestHasError: true,
        requestIsSuccess: false,
      };
    default:
      return state;
  }
};
